import { TLocale } from '@/config/locales';
import { TAccountType } from '@/services/types/auth/ILoginForm';
import { buildSocialAuthUrl } from '@/utility/buildSocialAuthUrl';
import { setItemInLocalStorage } from '@/utility/localstorage';
import { rememberSSOAuthOriginURL } from '@/utility/sso';

/**
 * Kick off the OAuth redirect for a social provider (Google/Facebook/Apple).
 * Shared by the social-auth buttons and the "Continue with {provider}" prompt shown
 * when someone enters a password for a social-login account.
 */
export const initiateSocialAuth = (method: TAccountType, locale: TLocale) => {
  rememberSSOAuthOriginURL();
  setItemInLocalStorage('social_auth_method', method);
  window.location.href = buildSocialAuthUrl(method, locale);
};
